import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

import { computed } from "vue";
import {
  GraphElementType,
  GraphMode,
  TimNodeCytoElement,
  TimNodeProps,
} from "@/types";
import { ENABLED_FEATURES, sanitizeNodeId } from "@/util";
import {
  timStore,
  appStore,
  selectionStore,
  useTheme,
  permissionStore,
  viewsStore,
} from "@/hooks";
import { CyElement } from "@/components/graph/base";
import { NodeDisplay } from "@/components/graph/display";
import { FlexBox, IconButton, Separator } from "@/components";


/**
 * Renders a TIM node within the graph.
 */
const __default__ = {
  name: "TimNode",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifactType: {},
    count: {},
    icon: {},
    hideActions: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const { darkMode } = useTheme();

const displayActions = computed(() =>
  permissionStore.isAllowed("project.generate")
);

const selected = computed(
  () => selectionStore.selectedArtifactLevelType === props.artifactType
);

const style = computed(() => (selected.value ? "z-index: 10;" : "z-index: 1;"));

const color = computed(() => timStore.getTypeColor(props.artifactType));

const countLabel = computed(() =>
  props.count < 0
    ? "1 Import"
    : props.count === 1
      ? "1 Artifact"
      : `${props.count} Artifacts`
);

const definition = computed<TimNodeCytoElement>(() => ({
  data: {
    type: GraphElementType.node,
    graph: "tim" as GraphMode,
    id: sanitizeNodeId(props.artifactType),

    artifactType: props.artifactType,

    dark: darkMode.value,
  },
}));

/**
 * Selects this artifact level.
 */
function handleSelect(): void {
  if (props.hideActions) return;

  if (!selected.value) {
    selectionStore.selectArtifactLevel(props.artifactType);
  } else {
    viewsStore.addDocumentOfTypes([props.artifactType]);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(CyElement), {
    definition: definition.value,
    style: _normalizeStyle(style.value),
    "data-cy": "tim-node",
    "data-cy-name": props.artifactType
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(NodeDisplay), {
        separator: "",
        color: color.value,
        variant: "tim",
        title: props.artifactType,
        subtitle: countLabel.value,
        selected: selected.value,
        onClick: handleSelect
      }, null, 8, ["color", "title", "subtitle", "selected"]),
      (selected.value)
        ? (_openBlock(), _createBlock(_unref(NodeDisplay), {
            key: 0,
            color: color.value,
            variant: "sidebar",
            selected: selected.value,
            onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
            onMouseup: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(FlexBox), { column: "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IconButton), {
                    tooltip: "View artifacts",
                    icon: "view-tree",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewsStore).addDocumentOfTypes([props.artifactType])))
                  }),
                  (displayActions.value)
                    ? (_openBlock(), _createBlock(_unref(Separator), {
                        key: 0,
                        class: "full-width q-my-xs"
                      }))
                    : _createCommentVNode("", true),
                  (displayActions.value && _unref(ENABLED_FEATURES).GENERATE_SUMMARIES)
                    ? (_openBlock(), _createBlock(_unref(IconButton), {
                        key: 1,
                        tooltip: "Summarize artifacts",
                        icon: "generate-summaries",
                        color: "gradient",
                        "data-cy": "button-summarize-artifact",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(appStore).openDetailsPanel('summarizeArtifact')))
                      }))
                    : _createCommentVNode("", true),
                  (displayActions.value)
                    ? (_openBlock(), _createBlock(_unref(IconButton), {
                        key: 2,
                        tooltip: "Generate parents",
                        icon: "generate-artifacts",
                        color: "gradient",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(appStore).openDetailsPanel('generateArtifact')))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["color", "selected"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["definition", "style", "data-cy-name"]))
}
}

})